import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import App from '../components/App';
import RouteSync from './RouteSync';
import { ErrorNotFound } from '../components/Error/Error';
import Start from '../containers/Start';
import ResearchTree from '../containers/ResearchTree';
import ResearchContent from '../components/Research/ResearchContent';
import ResearchViewer from '../containers/ResearchViewer';
import BuildAndTestTree from '../containers/BuildAndTestTree';
import EngineeringToolbar from '../containers/EngineeringToolbar';
import EngineeringWorkAreas from '../containers/EngineeringWorkAreas';
import Simulation from '../containers/Simulation';
import OutputsToolbar from '../containers/OutputsToolbar';
import OutputsViewer from '../containers/OutputsViewer';
import LoginModal from '../containers/LoginModal';
import AppSelector from '../containers/AppSelector';
import JournalTree from '../containers/Journal/JournalTree';
import JournalContent from '../components/Journal/JournalContent';
import { setMainPage } from '../actions/app';
import * as pages from '../constants/pages';
import { routes } from '../config/routes';

const mapStateToProps = (state) => {
  let panels;
  let page = state.app.page;

  if (state.auth.authenticated === false) {
    panels = [<LoginModal key="login" />];
  } else if (state.app.code.length === 0) {
    panels = [<AppSelector key="app-selector" />];
  } else {
    switch (page) {
      case pages.PAGE_HOME:
        panels = [<Start key="start" />];
        break;
      case pages.PAGE_RESEARCH:
        const researchPage = state.research.exercises.find(
          (ex) => ex.code === state.research.selectedPage
        );
        const category = researchPage !== undefined && researchPage.category;
        panels = [
          <ResearchTree key="research-tree" />,
          <ResearchContent key="research-activity" category={category} />,
        ];
        break;
      case pages.PAGE_JOURNAL:
        panels = [
          <JournalTree key="journal-tree" />,
          <JournalContent
            key="journal-content"
            page={state.journal.selectedPage}
          />,
        ];
        break;
      case pages.PAGE_ENGINEERING:
        panels = [
          <EngineeringToolbar key="engineering-toolbar" />,
          <EngineeringWorkAreas key="engineering-workareas" />,
        ];
        break;
      case pages.PAGE_SIMULATION:
        panels = [<Simulation key="simulation" />];
        break;
      case pages.PAGE_BUILD:
        panels = [
          <BuildAndTestTree key="build-tree" />,
          <ResearchViewer key="research-viewer" />,
        ];
        break;
      case pages.PAGE_OUTPUTS:
        panels = [
          <OutputsToolbar key="outputs-toolbar" />,
          <OutputsViewer key="outputs-viewer" />,
        ];
        break;
      default:
        panels = [<ErrorNotFound key="error-404" />];
        break;
    }
  }

  return {
    appLoading: state.app.loading,
    unityLoading: state.unity.loading,
    loadingEnterTransition: state.app.initialized,
    notifications: state.notifications,
    showNavbar: !(state.app.page === pages.PAGE_HOME || !state.app.initialized),
    showFileManager: state.filemanager.visible,
    showGameModal: state.game.visible,
    panels,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gotoPage: (page) => dispatch(setMainPage(page)),
  };
};

// Connected App component that receives panels based on Redux state
const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

// Router wrapper component that includes RouteSync and route definitions
const Router = () => (
  <>
    {/* Sync URL changes with Redux state */}
    <RouteSync />

    {/* Define routes - all render the same ConnectedApp,
        which shows different panels based on Redux state */}
    <Switch>
      <Route exact path={routes[pages.PAGE_HOME]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_RESEARCH]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_ENGINEERING]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_SIMULATION]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_OUTPUTS]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_BUILD]} component={ConnectedApp} />
      <Route exact path={routes[pages.PAGE_JOURNAL]} component={ConnectedApp} />

      {/* Redirect any unknown routes to home */}
      <Route>
        <Redirect to={routes[pages.PAGE_HOME]} />
      </Route>
    </Switch>
  </>
);

export default Router;
